// extracted by mini-css-extract-plugin
export default {"container":"search_type_selector-module__container--3jRNc","wrapper":"search_type_selector-module__wrapper--1yAR7","dropdown":"search_type_selector-module__dropdown--1uqhm"};